// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"e7083d8d","160":"cc7b17a5","208":"1ecadada","293":"031c39db","516":"d720650d","519":"25b8de67","840":"d5c10af9","917":"e3011f24","946":"beb4fbbb"}[chunkId] + ".chunk.js";
};